var invoke = require('./invoke')

var invokeMap = invoke

module.exports = invokeMap



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/array/invokeMap.js
// module id = 1863
// module chunks = 106